import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCity } from "../context/CityContext";
import { getUpcomingEvents } from "../services/eventService";

const UpcomingEvents = () => {
  const { city } = useCity();
  const navigate = useNavigate();

  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (city) {
      fetchData();
    }
  }, [city]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getUpcomingEvents(city);
      setBanners(response.data || []);
    } catch (error) {
      console.error("Error fetching upcoming events:", error);
    } finally {
      setLoading(false);
    }
  };

  // 🔥 Handle Banner Click
  const handleBannerClick = (item) => {
  const eventCount = item.events ? item.events.length : 0;
  const titleObj =  item.dateFilterName.charAt(0).toUpperCase() + item.dateFilterName.slice(1).toLowerCase()
    navigate("/events", {
      state: {
        events: item.events || [],   // make sure API returns events list
        title: `${titleObj} (${eventCount}) Shows`,
      },
    });
  };

  return (
    <div className="max-w-6xl mx-auto px-0 py-6">
      <h2 className="text-3xl font-semibold font-['Inter'] text-left mb-8">
        Upcoming Events
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-4 gap-6">
        {banners.slice(0, 4).map((item, index) => (
          <div key={index} className="flex justify-center">
            <div className="w-full bg-white flex items-center justify-center">
              <img
                src={item.imageUrl}
                alt={item.dateFilterName}
                onClick={() => handleBannerClick(item)}
                className="max-h-full max-w-full object-contain cursor-pointer
                           transition-transform duration-300 hover:scale-105"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpcomingEvents;